import { useHistory } from "react-router-dom"
import { Container } from "src/components/container"
import { Button } from "src/components/ui/button"
import { ChevronRight, Corporate, Private } from "src/icons"
import { CheckRow } from "./CheckRow"
import { PriceCard } from "./PriceCard"
import "./style.scss"

export const Possibilities = () => {
  const history = useHistory()
  return (
    <div className="possibilities">
      <Container>
        <div className="possibilities__header">
          <div className="possibilities__header-chip">Unlimited Possibilities</div>
          <h1>For those who don’t wait — they move</h1>
          <span>
            7Gates delivers high-speed transfers and instant credits with the sophistication you expect. Choose the package that suits your
            rhythm.
          </span>
        </div>
        <div className="possibilities-cards">
          <div>
            <div className="possibilities-cards__header left-header">
              <div className="possibilities-cards__header-chip">
                <Private />
                Private vIBAN
              </div>
              <p>Ideal for digital nomads, freelancers,and crypto users seeking global freedom without bureaucracy.</p>
              <div className="possibilities-cards__header-prices">
                <PriceCard price={30} description="Opening" />
                <PriceCard price={15} description="Per month" />
                <PriceCard price={3} percent={0.3} description="Payments" />
              </div>
            </div>
            <div className="possibilities-cards__footer">
              <CheckRow title="Get paid from anywhere — salaries, freelance gigs, or transfers from crypto exchanges." />
              <CheckRow title="Top up with crypto and instantly convert to fiat." />
              <CheckRow title="Use it like a traditional bank account — send SEPA/SWIFT transfers, pay bills, and shop online." />
              <CheckRow title="No credit checks — quick access with no traditional banking hurdles." />
            </div>
            <div className="possibilities-cards__button">
              <Button onClick={() => history.push("/register/personal")} rightIcon={<ChevronRight />}>
                Get IBAN
              </Button>
            </div>
          </div>
          <div>
            <div className="possibilities-cards__header right-header">
              <div className="possibilities-cards__header-chip">
                <Corporate />
                Corporate vIBAN
              </div>
              <p>
                Perfect for international IT firms, service providers, and crypto-first businesses seeking dependable and streamlined
                financial operations.
              </p>
              <div className="possibilities-cards__header-prices">
                <PriceCard price={990} description="Opening" />
                <PriceCard price={100} description="Per month" />
                <PriceCard price={6} percent={0.3} description="Per Payment" />
              </div>
            </div>
            <div className="possibilities-cards__footer">
              <CheckRow dark title="Easily fund your company’s IBAN with crypto (BTC, ETH, USDT, and others)" />
              <CheckRow dark title="Convert digital assets to fiat (EUR, USD, GBP) instantly" />
              <CheckRow dark title="Accept crypto payments from clients, partners, or your treasury" />
              <CheckRow dark title="Send and receive SEPA/SWIFT transfers globally for payments to clients, vendors, and partners" />
            </div>
            <div className="possibilities-cards__button">
              <Button onClick={() => history.push("/register/corporate")} rightIcon={<ChevronRight />} className="dark-iban-button">
                Get IBAN
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}
